/* eslint-disable react/display-name */
import React, { useState, useEffect, useRef } from 'react'
import ReCAPTCHA from 'react-google-recaptcha'
import { Link } from 'react-router-dom'
import Required from './Required'
import { apiPost } from '../../Apis'
import { useDetectedDevice } from '../../WindowSize'
import Version from '../../Version'
import Waiting from '../../Waiting'
import { openAlert } from '../../UtilsIcons'

/* ANTD */
import Button from 'antd/es/button'
import Input from 'antd/es/input'
import Alert from 'antd/es/alert'

/* ANTD MOBILE */
import Flex from 'antd-mobile/es/flex'
import { WhiteSpace } from 'antd-mobile'

import 'antd/dist/antd.css'
import 'antd-mobile/dist/antd-mobile.css'

const Forgot = (props) => {
  const [device] = useDetectedDevice()
  const [user, setUser] = useState(process.env.REACT_APP_USER_PRE)
  const [recaptchaKey, setRecaptchaKey] = useState('')
  const [waiting, setWaiting] = useState(true)
  const [errorMessage, setErrorMessage] = useState('')
  const [enableSend, SetEnableSend] = useState(false)
  const refCaptcha = useRef('')

  // const handleForgot = () => {
  //   setWaiting(true)
  //   const newPost = {
  //     value: user
  //   }
  //   apiPost('auth', 'api/EnrollUser/RecoverPassword', newPost, onSuccess, onError)
  // }

  const handleForgot = () => {
    setWaiting(true)
    let apiPath = process.env.REACT_APP_ENV !== "DEV" ? "connect/api/EnrollUser/EnrollUser/RecoverPassword" : "api/EnrollUser/EnrollUser/RecoverPassword"

    const newPost = {
      Email: user
    }
    apiPost('auth', apiPath, newPost, onSuccess, onError)
  }
  
  const onSuccess = (response, data, tag) => {
    if (response.data.success) {
      openAlert(('Acción exitosa'),
        'Acabamos de enviarle un correo eléctronico con un enlace para cambiar su contraseña. Favor de cerrar esta ventana.',
        [{ text: 'Aceptar', onPress: onCloseAlert }])
    } else {
      // setErrorMessage(response.data.message)
      setErrorMessage('El correo ya fue enviado a su cuenta.')
    }
    setWaiting(false)
  }

  const onError = (response, data, tag) => {
    setErrorMessage(response.message)
    setUser('')
    setWaiting(false)
  }

  const handleChangeData = (name, value) => {
    if (name === 'user') {
      setUser(value)
    }
  }

  const closeMessage = () => {
    setErrorMessage('')
  }

  const onChangeCaptcha = (value) => {
    SetEnableSend(true)
  }

  const onCloseAlert = () => { }

  useEffect(() => {
    setWaiting(false)
    setRecaptchaKey(Date.now().toString())
  }, [])


  // if (currentUserState.isAuthenticated) {
  //   return <Redirect to='/' />
  // }

  return (
    <div>
      <div className='element-body-mobile'>
        <div className="flex-container">
          <div className="element-page-title">{'Reestablecer contraseña'}</div>
          <WhiteSpace size="lg" />
          <Flex>
            <Flex.Item>
              <div><label className='element-form-label'>{'Confirma tu correo electrónico para poder reestablecer tu contraseña'}</label></div>
              <Input placeholder='' style={{ width: device === 'browser' ? '300px' : (device === 'tablet' ? '50%' : '90%') }} maxLength={250}
                onChange={e => handleChangeData('user', e.target.value)}
                value={user} />
              <Required required={!user} />
              {
                errorMessage !== '' && (
                  <div>
                    <WhiteSpace size="lg" />
                    <Alert message={errorMessage} closable afterClose={closeMessage} type="error" style={{ width: device === 'browser' ? '300px' : (device === 'tablet' ? '50%' : '90%') }} />
                  </div>
                )
              }
            </Flex.Item>
          </Flex>

          <WhiteSpace size="lg" />
          <Flex>
            <Flex.Item>
              {recaptchaKey &&
                <ReCAPTCHA
                  key={'rc' + recaptchaKey}
                  ref={refCaptcha}
                  sitekey={process.env.REACT_APP_CAPTCHA_KEY}
                  hl={'es'}
                  onChange={onChangeCaptcha}
                />
              }
            </Flex.Item>
          </Flex>

          <WhiteSpace size="lg" />
          <Flex>
            <Flex.Item>
              <Link to="/Login">{'Cancelar'}</Link>
            </Flex.Item>
          </Flex>

          <WhiteSpace size="lg" />
          <WhiteSpace size="lg" />
          <Flex justify={device === 'phone' ? 'center' : 'start'}>
            <Button disabled={enableSend === false} onClick={handleForgot} type="primary" shape="round" icon="check" >{'Enviar'}</Button>
          </Flex>
          <WhiteSpace size="lg" />
          <WhiteSpace size="lg" />
        </div>
      </div>
      <Version />
      <Waiting show={waiting} />
    </div>
  )
}

export default Forgot
